const { getProjectStatusText } = require('./projectStatusType')
const { getProjectTypeName } = require('./projectType')
const { getPurchaseTypeName } = require('./purchaseType')
const mixin = {
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbProgressBaseInfo`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.header = res.data
                this.header.title = res.data.gcName
                this.header.status = res.data.bidStatus
                this.header.statusText = getProjectStatusText(res.data.bidStatus)
                this.header.code = res.data.gcBH
                this.header.type = getPurchaseTypeName(res.data.zbFangShi)
                this.header.projectType = getProjectTypeName(res.data.xmLeiXing)
                this.header.creator = res.data.creator
                // 公告标段Guid
                this.header.ggBDGuid = res.data.ggBDGuid
                this.getNodeFields()
            })
        },
        getNodeFields() {
            if (this.header.status >= this.nodes[0].value) {
                this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                    bdGuid: this.$route.query.id,
                }).then((res) => {
                    if (!res.data.bdGuid) {
                        delete this.nodes[0].actions
                    }
                    // 招标节点
                    this.nodes[0].fields[0].value = res.data.ggZhuangTai ? '已发布' : '未发布'
                    this.nodes[0].date = this.$util.timeFormatter(res.data.ggStartTime)
                    this.nodes[0].fields[1].value = this.nodes[0].date
                })
            }
            if (this.header.status >= this.nodes[3].value) {
                this.$request
                .post(
                    '/transformToAfter/app/open/hall/kb/detail',
                    {
                        bdGuid: this.$route.query.id,
                    },
                )
                .then((res) => {
                    if (res.data) {
                    this.nodes[3].fields[0].value = res.data.afterTrialOpenBidTime || res.data.preTrialBdGuid
                    this.nodes[3].fields[1].value = ''
                    this.nodes[3].fields[2].value = ''
                    this.nodes[3].fields[3].value = res.data.decryptNum
                    }
                })
            }
        },
    },
}

module.exports = {
    mixin,
}
